export default __webpack_public_path__ + "static/media/PERL.d41eceda.pdf";